import React from 'react';

interface CharacterCounterProps {
  current: number;
  limit: number;
  label?: string;
  showProgressBar?: boolean;
}

export default function CharacterCounter({
  current,
  limit,
  label,
  showProgressBar = true
}: CharacterCounterProps) {
  const percentage = (current / limit) * 100;
  const remaining = limit - current;

  const getColor = () => {
    if (percentage > 100) return 'text-red-600 bg-red-100';
    if (percentage > 90) return 'text-orange-600 bg-orange-100';
    if (percentage > 70) return 'text-yellow-600 bg-yellow-100';
    return 'text-green-600 bg-green-100';
  };

  const getProgressColor = () => {
    if (percentage > 100) return 'bg-red-500';
    if (percentage > 90) return 'bg-orange-500';
    if (percentage > 70) return 'bg-yellow-500';
    return 'bg-green-500';
  };

  return (
    <div className="space-y-1">
      {showProgressBar && (
        <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
          <div
            className={`h-full transition-all duration-300 ${getProgressColor()}`}
            style={{ width: `${Math.min(percentage, 100)}%` }}
          />
        </div>
      )}

      <div className="flex items-center justify-between text-xs">
        <span className="text-gray-600">
          {label || 'Characters'}
        </span>
        <span className={`px-2 py-0.5 rounded-full font-medium ${getColor()}`}>
          {current} / {limit}
          {percentage > 100 && (
            <span className="ml-1 font-bold">
              ({Math.abs(remaining)} over)
            </span>
          )}
        </span>
      </div>
    </div>
  );
}